import { Component, OnInit } from '@angular/core';

import { TableConfig } from '../../shared/components/app-table/app-table-models';
import { LarmKriteriumService } from './larm-kriterium.service';
import { LarmKriteriumDTO } from '../../shared/models/models';
import { ActivatedRoute } from '@angular/router';
import { AuthorizationService } from 'src/app/auth/services/authorization.service';
import { Role } from '../anvandare/anvandare.models';

export enum LarmTyp {
  NATIONELL_PUBLIK = 'Publikt',
  NATIONELL_INTERN = 'Internt',
  LOKALT = 'Lokalt',
}

@Component({
    selector: 'lib-larm-kriterium',
    templateUrl: './larm-kriterium.component.html',
    styleUrls: ['./larm-kriterium.component.scss'],
    standalone: false
})
export class LarmKriteriumComponent {
  protected larmkriteria: LarmKriteriumDTO[] = [];
  protected expanded!: { id: string };
  protected tableConfig: TableConfig = {
    accordionContent: 'larm-kriterium-details',
  };
  protected hasEditRights = false;

  constructor(
    private route: ActivatedRoute,
    private larmKriteriumService: LarmKriteriumService,
    private authorizationService: AuthorizationService,
  ) {
    this.hasEditRights = this.authorizationService.hasRole([Role.SuperanvandareIntern]);
    this.larmKriteriumService.getAllKriteria().subscribe((data) => {
      this.larmkriteria = data as LarmKriteriumDTO[];
      this.tableConfig.rows = data as any[];
      this.expandKriteria();
    });

    this.tableConfig.columns = [
      { field: 'toggler', header: '', isRowToggler: true },
      {
        field: 'name',
        header: 'Namn',
        sortByField: 'name',
      },
      { field: 'species', header: 'Smittämne', sortByField: 'species', headerClasses: ['hide-headers'] },
      {
        field: 'type',
        header: 'Typ av kriterium',
        sortByField: 'type',
        mapView: (type: string) => LarmTyp[type as keyof typeof LarmTyp],
        headerClasses: ['hide-headers'],
      },
      {
        field: 'status',
        header: 'Status',
        sortByField: 'status',
        mapView: (status: string) => (status === 'AKTIV' ? 'Aktivt' : 'Inaktivt'),
        headerClasses: ['hide-headers'],
      },
    ];
  }

  private expandKriteria() {
    const kriteria = this.route.snapshot.queryParamMap.get('kriteria');
    if (kriteria) {
      const id = this.tableConfig.rows?.find((row) => row.name === kriteria)?.id;
      this.expanded = { id };
    }
  }
}
